<template>
  <div class="coins-list">
    <div class="section-title-and-switch">
      <span>{{ lang.marketsLabel }}</span>
      <SwitchComponent
        :defaultValue="tradeTo"
        :type2="true"
        @change="
          (baseCoin) => $router.push(`/Panel/Trade/${baseCoin}/${tradeFrom}`)
        "
        :items="tradeFrom == 'TETHER' ? ['TOMAN'] : ['TOMAN', 'TETHER']"
      />
    </div>
    <table>
      <tr class="table-header">
        <td>{{ lang.tableHeaders.coin }}</td>
        <td>{{ lang.tableHeaders.price }}</td>
        <td>{{ lang.tableHeaders.change }}</td>
      </tr>
      <tr
        v-for="(item, index) in tickerPrices"
        :key="index"
        class="table-row"
        @click="$router.push(`/Panel/Trade/${tradeTo}/${item.destCoinSymbol}`)"
      >
        <td class="coin-title">
          <img class="coin-icon" :src="$coins[item.destCoinSymbol].link" />
          {{
            $isPersian()
              ? $coins[item.destCoinSymbol].persianName
              : $coins[item.destCoinSymbol].englishName
          }}
        </td>
        <td>{{ $toLocal(item.price, $decimal[tradeTo]) }}</td>
        <td
          :class="{
            red: item.price24hrChangePercent < 0,
            green: item.price24hrChangePercent >= 0,
          }"
        >
          {{
            Number.parseFloat(item.price24hrChangePercent)
              .toFixed(2)
              .replace("-", "")
          }}%
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import SwitchComponent from "../../Tools/SwitchComponent";

import { tradeTo, tradeFrom } from "@/library/reuseableFunction";

export default {
  name: "CoinsList",
  components: {
    SwitchComponent,
  },
  props: ["tickerPrices"],
  data() {
    return {
      lang: this.$languageDict().trade.coinsList,
    };
  },
  computed: {
    tradeTo,
    tradeFrom,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.persian {
  td:first-child {
    text-align: right;
  }
  td:last-child {
    text-align: left;
    border-radius: 6px 0px 0px 6px;
  }
}
.coin-title {
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.section-title-and-switch {
  font-size: clamp(16px, 1.8vw, 20px);
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  color: white;
  align-items: center;
}

.coins-list {
  background: #1d2050;
  border-radius: 8px;
  padding: 16px 8px 8px 8px;
  max-height: 710px;
  overflow: auto;
}

.dropdown {
  padding: 0px 16px;
  border-radius: 20px;
}

.coin-icon {
  width: clamp(18px, 2.1vw, 24px);
}

.icon {
  stroke: var(--dropdown-icon);
}

.table-header {
  color: #bdbdbd;
  font-size: clamp(11px, 1.2vw, 13px);
}

table {
  width: 100%;
  margin-top: 28px;
  border-collapse: collapse;
  text-align: center;
}

td {
  padding: 10px 0px;
}

.green {
  color: #80b73b;
}

.red {
  color: #dd1b60;
}

td:last-child {
  border-radius: 0px 6px 6px 0px;
  text-align: right;
  padding-right: 4px !important;
}

td:first-child {
  text-align: left;
  border-radius: 6px 0px 0px 6px;
  padding-left: 4px !important;
}

.table-row {
  color: #f2f2f2;
  font-size: clamp(12px, 1.3vw, 14px);
  cursor: pointer;

  &:hover {
    background: rgba(251, 250, 250, 0.8);
    color: #cb07c3;
  }
}
</style>
